// extracted by mini-css-extract-plugin
export default {"campaignsTop":"CampaignsPage_campaignsTop__mncUB","campaignsTitle":"CampaignsPage_campaignsTitle__yNHuu","campaignsMainContent":"CampaignsPage_campaignsMainContent__NEhhU"};